var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramGs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1081",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1081",
    transform: "translate(-380 -413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1133",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1133",
    d: "M47.856,14.1A17.62,17.62,0,0,0,46.74,8.279a11.762,11.762,0,0,0-2.768-4.251,11.766,11.766,0,0,0-4.251-2.769A17.616,17.616,0,0,0,33.9.145C31.336.028,30.518,0,24,0s-7.336.028-9.9.144A17.622,17.622,0,0,0,8.279,1.26,11.762,11.762,0,0,0,4.028,4.028,11.765,11.765,0,0,0,1.259,8.279,17.618,17.618,0,0,0,.145,14.1C.028,16.664,0,17.482,0,24s.028,7.336.145,9.9A17.615,17.615,0,0,0,1.26,39.721a11.761,11.761,0,0,0,2.768,4.251A11.759,11.759,0,0,0,8.28,46.739a17.61,17.61,0,0,0,5.826,1.116c2.56.117,3.377.144,9.9.144s7.336-.027,9.9-.144a17.612,17.612,0,0,0,5.826-1.116,12.27,12.27,0,0,0,7.019-7.019A17.614,17.614,0,0,0,47.856,33.9c.116-2.56.144-3.377.144-9.9S47.972,16.664,47.856,14.1ZM43.536,33.7a13.279,13.279,0,0,1-.826,4.456,7.948,7.948,0,0,1-4.555,4.555,13.279,13.279,0,0,1-4.456.826c-2.53.116-3.289.14-9.7.14s-7.168-.024-9.7-.14a13.283,13.283,0,0,1-4.456-.826,7.438,7.438,0,0,1-2.759-1.8,7.435,7.435,0,0,1-1.8-2.759A13.279,13.279,0,0,1,4.464,33.7c-.115-2.531-.14-3.29-.14-9.7s.025-7.167.14-9.7A13.288,13.288,0,0,1,5.29,9.846a7.441,7.441,0,0,1,1.8-2.76,7.431,7.431,0,0,1,2.76-1.8A13.276,13.276,0,0,1,14.3,4.464c2.531-.115,3.29-.14,9.7-.14h0c6.408,0,7.167.025,9.7.14a13.281,13.281,0,0,1,4.456.826,7.441,7.441,0,0,1,2.759,1.8,7.431,7.431,0,0,1,1.8,2.76,13.267,13.267,0,0,1,.827,4.456c.115,2.531.14,3.29.14,9.7S43.651,31.167,43.536,33.7Zm0,0",
    transform: "translate(380 413)",
    fill: "#bfbdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1134",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1134",
    d: "M135.049,124.539a10.51,10.51,0,1,0,10.51,10.51A10.51,10.51,0,0,0,135.049,124.539Zm0,17.332a6.822,6.822,0,1,1,6.823-6.823A6.822,6.822,0,0,1,135.049,141.872Zm0,0",
    transform: "translate(268.984 301.984)",
    fill: "#bfbdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1135",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1135",
    d: "M367,91.161a2.536,2.536,0,1,1-2.536-2.536A2.536,2.536,0,0,1,367,91.161Zm0,0",
    transform: "translate(52.586 332.826)",
    fill: "#bfbdc5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramGs);
export default __webpack_public_path__ + "static/media/instagram-gs.3e556c01cacedeefa61cdd9365b4f378.svg";
export { ForwardRef as ReactComponent };